import styled from 'styled-components'

export const Collection = styled.ul`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 0;

  :hover {
    cursor: pointer;
  }
`

export const CollectionItem = styled.li`
  position: relative;
  margin: 0 5px 10px 5px;
  width: calc(50% - 16px);
  height: 126px;

  & > * {
    border-radius: 6px;
  }
`

export const Photo = styled.img`
  display: block;
  width: 100%;
  height: 126px;
  object-fit: cover;
`



// WEBPACK FOOTER //
// ./src/components/Collection/index.js